import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  CoreService,
  IResponse
} from 'src/app/@amiga-pyme/services/core.service';
import { ILogin } from '../interfaces/login.interface';
import { lastValueFrom } from 'rxjs';

export const ROUTE_LOGIN = '/auth/sign-in';
@Injectable({
  providedIn: 'root'
})
export class LoginService extends CoreService {
  constructor(http: HttpClient) {
    super(http);
  }
  async login(user: ILogin): Promise<IResponse> {
    const response = await lastValueFrom(
      this.request({ method: 'POST', url: ROUTE_LOGIN, data: user })
    );
    return {
      message: response.body.message,
      data: response.body.data,
      status: response.status
    };
  }
}
